import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { RecoilRoot } from "recoil";
import RecoilNexus from "recoil-nexus";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ConfirmRecoilModal from "./components/modal/ConfirmRecoilModal";
import CustomToast from "./components/modal/CustomToast";

// import SocketService from "./screens/socket/Socket";

if (
  process.env.REACT_APP_ENV != undefined &&
  process.env.REACT_APP_ENV === "PRD"
) {
  console.log = () => null;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <>
    <RecoilRoot>
      <RecoilNexus />
      {/* <SocketService /> */}
      <BrowserRouter
        basename={
          process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : ""
        }
      >
        <App />
      </BrowserRouter>
      <ConfirmRecoilModal />
      <CustomToast message="" type="success" />
    </RecoilRoot>
  </>
);

reportWebVitals();
